import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { format, parseISO, fromUnixTime, formatDistanceToNow } from 'date-fns';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import { Link } from 'react-router-dom';

// Firebase
import { db } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../actions/alertActions';
import { createChat } from '../../actions/chatActions';
import { getUserById } from '../../actions/authActions';

// Light Box
import { SRLWrapper } from "simple-react-lightbox";

// Components - material UI
import { Avatar, Button } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';
import Tag from '../common/Tag';

// Modal
import Modal from '../modal/Modal';
import ModalContainer from '../modal/ModalContainer';

// Icons - material UI
import DateRangeIcon from '@material-ui/icons/DateRange';
import { toggleProfileModal, toggleAuthModal } from '../../actions/navActions';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import LinkIcon from '@material-ui/icons/Link';
import CheckIcon from '@material-ui/icons/Check';
import DeleteIcon from '@material-ui/icons/Delete';
import Verification_Badge from '../common/Verification_Badge';
import MailIcon from '@material-ui/icons/Mail';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';

const ProfileHeader = ({ 
    setAlert,
    createChat,
    getUserById,
    toggleProfileModal, 
    toggleAuthModal,
    toggleEdit, 
    showMessageModal,
    auth: { 
        modalUser,
        profileUser,
        user 
    },
    nav: {
        website,
        website_loading
    },
    history
}) => {

    // Toggle Dropdown
    const [dropdown, setDropdown] = useState(false);
    const [menuHeight, setMenuHeight] = useState(null);

    // Edit Modal toggles
    const [copied, setCopied] = useState(false);
    const [messageModal, setMessageModal] = useState(false);
    
    // Get the current URL and extract the "show" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("show");

    // Copied Modal timer logic
    useEffect(() => {
        setTimeout(() => {
            setCopied(false);
        }, 1000);
    }, [copied]);

    useEffect(() => {
        if(profileUser) {

            // Redirect to the user's profile if showMessageModal is true
            if(showMessageModal === 'true') {
                toggleMessageModal();

                window.location.href = `/user/${profileUser._id}`;
            }
        }

    }, [profileUser])

    // -- Message Logic --

    // Handle Toggling of Message Modal
    const handleMessageModal = () => {
        toggleMessageModal();
    }

    const toggleMessageModal = () => {

        // Get user by ID if the message modal is not currently open
        if(!messageModal) getUserById(profileUser._id);
        
        setMessageModal(!messageModal);
    }

    const continueMessage = () => {
        if(user) {
            createNewChat();
        } else {
            toggleMessageModal();
            toggleAuthModal('message');
        }
    }

    // Create a new chat between users
    const createNewChat = async () => {
        try {
            // Query existing chats between users
            const chatsCollectionRef = collection(db, "chats");

            // Check if chat with 2 users already exists by chat ID
            
            const chatsQuery = query(chatsCollectionRef, where("from_user._id", "==", user._id), where("to_user._id", "==", modalUser._id));
            const otherChatsQuery = query(chatsCollectionRef, where("to_user._id", "==", user._id), where("from_user._id", "==", modalUser._id));

            const chatsSnapshot = await getDocs(chatsQuery);
            const chats = chatsSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

            const otherChatsSnapshot = await getDocs(otherChatsQuery);
            const otherChats = otherChatsSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

            // If array length > 0 then there is already existing chat & redirect instead
        
            if(chats.length > 0) {
                window.location.href = `/messages/${chats[0]._id}`;
            } else if (otherChats.length > 0) {
                window.location.href = `/messages/${otherChats[0]._id}`;
            } else {
                createChat(modalUser, user);
            }

            setMessageModal(!messageModal);
            
            console.log('SHOULD BE DONE CREATING');

        } catch (error) {
            console.log('Failed to create new chat');
            // console.log(error);
            setAlert('Unable to start conversation', 'danger');
        }
    }

    // -- END: Message Logic --

    // Handle logic for the Copied Modal
    const toggleCopiedModal = () => {
        setDropdown(false);
        
        // setCopiedModal(!copiedModal);
        setAlert('Copied to clipboard', `${user ? 'okay' : 'success'}`);
        
    }

    // Handle logic for Reporting User
    const reportUser = () => {
        setDropdown(false);
        
        // Show 'User Reported' Alert
        setAlert('User Reported. Thanks for letting us know.', `${user ? 'okay' : 'success'}`);
    }

    // Handle Claim Account logic
    const handleClaimAcct = () => {
        setDropdown(false);

        // Open claim account link in a new window
        window.open(`/login/sent?email=${profileUser && profileUser.email}`)
    }

    // Function to capitalize the first letter of a string
    const capitalizeFirstLetter =(string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    // Options for a component (possibly related to a slideshow or gallery)
    const options = {
        caption: {
            showCaption: false
          },
        thumbnails: {
            showThumbnails: false
        },
        buttons: {
            showAutoplayButton: false,
            showFullscreenButton: false,
            showNextButton: false,
            showPrevButton: false,
            showThumbnailsButton: false,
        }
    }
    
    return (
        <Fragment>
            {/* SRLWrapper is a lightbox for full screen image display */}
            <SRLWrapper options={options}>
                <div className="profile__header">

                    {/* Dropdown Button */}
                    <div className='profile__moreBtns'>
                        <div onClick={() => setDropdown(!dropdown)} className="profile__moreBtn">
                            <MoreHorizIcon />
                        </div>
                    </div>

                    {/* Dropdown Menu */}
                    <div className={dropdown ? "edit-dropdown active" : "edit-dropdown"} style={{height: menuHeight}}>
                        <div className="menu">

                            {/* Copy Link to Profile option */}
                            <CopyToClipboard 
                                text={`${website ? website.url : process.env.REACT_APP_DOMAIN}/user/${profileUser && profileUser._id}?redirect=true`}
                                onCopy={toggleCopiedModal}
                            >
                                <div className="menu-item">
                                    <LinkIcon />
                                    Copy link to profile
                                </div>
                            </CopyToClipboard>

                            {/* Claim Account option */}
                            {profileUser && !profileUser.verified ? (
                                <div onClick={handleClaimAcct} className="menu-item blue">
                                {/* <PersonAddAltOutlinedIcon /> */}
                                Claim this account 
                            </div>
                            ) : null}
                            
                            {/* Report User option */}
                            {user && profileUser && profileUser._id !== user._id ? (
                                <div onClick={reportUser} className="menu-item danger">
                                    {/* <OutlinedFlagTwoToneIcon /> */}
                                    Report 
                                    <b style={{marginLeft:'5px'}}>{profileUser && `${profileUser.first_name }${profileUser.last_name && ' ' + profileUser.last_name}`}</b>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    {/* Overlay for the Dropdown */}
                    <div
                        className={`hidden-overlay ${dropdown ? "show" : ""}`}
                        onClick={() => setDropdown(!dropdown)}
                    />

                    {/* Profile Image */}
                    <div className="profile__image">
                        <a href={profileUser && profileUser.img}>
                            {profileUser && profileUser.img ? (
                                <Avatar src={profileUser.img} />
                            ) : (
                                <DefaultAvatar name={`${profileUser.first_name} ${profileUser.last_name}`} />
                            )}
                        </a>
                    </div>

                    {/* Profile User Name */}
                    <div className="profile__headerBody">
                        <h3>
                            {profileUser && profileUser.first_name}{profileUser && profileUser.last_name ? ` ${profileUser.last_name}` : ''}
                            <span className="profile__headerSpecial">
                                {/*@{profileUser && profileUser.username}*/}
                                <Verification_Badge user={profileUser} />
                            </span>
                        </h3>
                    </div>

                    {/* Profile Stats */}
                    {/* <div className="profile__stats">
                        <p><span className="profile__specialStat">451</span> Bought</p>
                        <p><span className="profile__specialStat">329</span> Sold</p>
                        <p><span className="profile__specialStat">1,015</span> Likes</p>
                    </div> */}

                    {/* Profile Bio */}
                    <div className="profile__description">
                        <p>{profileUser && profileUser.bio?.slice(0, 160)}</p>
                    </div>
                    
                    {/* Profile Membership */}
                    {profileUser?.verified && (
                        <div className="profile__membership">
                            <DateRangeIcon />
                            {profileUser?.date && <p>Joined {format(profileUser.date, "MMMM yyyy")} </p>}
                        </div>
                    )}

                    {/* Edit Profile or Send Message Button */}
                    {user && profileUser && profileUser._id === user._id ? (
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet ghost" 
                            fullWidth
                            onClick={user.profile_set_up ? toggleEdit : toggleProfileModal}
                        >
                            {user.profile_set_up ? 'Edit Profile' : 'Set up profile'}
                        </Button>
                    ) : (
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet ghost icon_18" 
                            fullWidth
                            onClick={handleMessageModal}
                        >
                            Send Message
                            <span style={{width: '5px'}}></span>
                            <MailIcon />
                        </Button>
                    )}

                    {/* Profile Header Tabs */}
                    <div className="profile__headerTabs">
                        
                        <a href={`${profileUser ? `/user/${profileUser._id}` : '/profile'}`}>
                            <div className={`${(filter === null || filter === undefined || filter === 'home') && 'active'}`}>
                                <h3>Posts</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>

                        <a href={`${profileUser ? `/user/${profileUser._id}` : '/profile'}?show=photos`}>
                            <div className={`${(filter && filter === 'photos') && 'active'}`}>
                                <h3>Photos</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>
        
                        <a href={`${profileUser ? `/user/${profileUser._id}` : '/profile'}?show=reviews`}>
                            <div className={`${(filter && filter === 'reviews') && 'active'}`}>
                                <h3 style={{whiteSpace: 'nowrap'}}>Reviews ({profileUser.review_count || 0})</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>
                        
                        {/* <a href={`/${profileUser ? profileUser.username : 'profile'}?show=likes`}>
                            <div className={`${(filter && filter === 'likes') && 'active'}`}>
                                <h3>Likes</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>  */}
                        {/* <Link to="/notifications/mentions">
                            <div>
                                <h3>Likes</h3>
                                <div className="block__underline"></div>
                            </div>
                        </Link> */}
                    </div>
                </div>
            </SRLWrapper>
        
            {/* Start a Conversation modal */}
            <ModalContainer show={messageModal} onClose={toggleMessageModal}>
                <Modal>

                    {/* Modal Title */}
                    <div>
                        <h2>Start Conversation?</h2>
                    </div>

                    {/* Modal Text */}
                    <p>Start a private conversation with <b style={{color: '#333'}}>{modalUser ? `${modalUser.first_name}${modalUser.last_name && ' ' + modalUser.last_name}` : 'this person'}</b></p>
                    
                    {/* Modal Actions */}
                    <Button 
                        onClick={continueMessage}
                        variant="outlined" 
                        className="sidebar__tweet black"
                        fullWidth
                    >
                        Start Conversation
                    </Button>
                    <Button 
                        onClick={toggleMessageModal}
                        variant="outlined" 
                        className="sidebar__tweet ghost blackText"
                        fullWidth
                    >
                        Cancel
                    </Button>
                </Modal>
            </ModalContainer>
        </Fragment>
    )
}

ProfileHeader.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    // Prop type validation for function to toggle the profile modal
    toggleProfileModal: PropTypes.func.isRequired,
    // Prop type validation for function to toggle the auth modal
    toggleAuthModal: PropTypes.func.isRequired,
    // Prop type validation for function to set alerts
    setAlert: PropTypes.func.isRequired,
    createChat: PropTypes.func.isRequired,
    getUserById: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the authentication state
    auth: state.auth,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert, 
    createChat,
    getUserById,
    toggleProfileModal, 
    toggleAuthModal 
})(ProfileHeader);
